export const MAIN_TITLE_SIZE = 20; // h1
export const SECTION_TITLE_SIZE = 18; // h2
export const CONTENT_TITLE_SIZE = 16; // h3
export const SUB_TITLE_SIZE = 16; // h4

export const mobileLogoWidth = 88;

export const SHOP_LOGO_WIDTH = 176;

export const REVIEWS_LIMIT = 8;
